$(document).ready(function () {
    setTimeout(function () {
        $('.rebuy-cart__flyout-content ul.rebuy-cart__flyout-items[role="group"]').attr("role", "list");

         $('.rebuy-cart__flyout-item-info > a.rebuy-cart__flyout-item-product-title').each(function () {
            // Wrap this anchor with <h5>
            $(this).removeAttr('role').removeAttr('aria-level');
            $(this).wrap('<h5 class="rebuy-cart__item-heading"></h5>');
        });

        $('#1763669626820_350644915463232').attr('title', 'Dental Professionals Form');

        $('.text-columns-with-images__grid .text-columns-with-images__item-heading').each(function () {
            if ($(this).is('h4')) {
            $(this).replaceWith('<h2 class="' + this.className + '" style="' + this.getAttribute("style") + '">' + $(this).html() + '</h2>');
            }
        });

        const $titlePrimaryTitle = $('.rebuy-widget-content h4.primary-title');
        if ($titlePrimaryTitle.length && $titlePrimaryTitle.is('h4')) {
            $titlePrimaryTitle.replaceWith(
            '<h3 class="' + $titlePrimaryTitle.attr('class') + '">' + $titlePrimaryTitle.html() + '</h3>'
            );
        }

        $('.needsclick img').attr('alt', 'Launch Party Signup Form Logo');
        $('.rte__iframe iframe').attr('title', 'Video: Overview of Ollie Fluoride product');
        
        $('#shopify-section-template--20068264902887__1659521440fcda1607 iframe').attr('title', 'Form: Ollie for Dental Professionals');   
        
        const $titleTypography = $('h3.Typography_header-small__F94WP');
        if ($titleTypography.length && $titleTypography.is('h3')) {
            $titleTypography.replaceWith(
            '<h2 class="' + $titleTypography.attr('class') + '">' + $titleTypography.html() + '</h2>'
            );
        }

        const $titleAccountHeading = $('.account__header .account__heading');
        if ($titleAccountHeading.length && $titleAccountHeading.is('h1')) {
            $titleAccountHeading.replaceWith(
            '<h2 class="' + $titleAccountHeading.attr('class') + '">' + $titleAccountHeading.html() + '</h2>'
            );
        }

        $('p.account__subheading').replaceWith(function () {
            return $('<h3>', {
                class: this.className,
                html: $(this).html()
            });
        });

        $('div._1fragem32 span').replaceWith(function () {
            return $('<h1>', {
                class: this.className,
                html: $(this).html()
            });
        });



    }, 3000);

    setTimeout(function () { 
        $('dt[data-role="instructions"]').wrap('<dl></dl>');
        $('label[role="radio"]').removeAttr('role aria-checked tabindex data-role');

    }, 5000);

    const $title = $('.featured-product__details .product__title');
    if ($title.length && $title.is('h1')) {
        $title.replaceWith(
        '<h2 class="' + $title.attr('class') + '">' + $title.html() + '</h2>'
        );
    }

    const $subheading = $('.image-with-text__subheading h6');
    if ($subheading.length) {
        $subheading.replaceWith(
        '<h3 class="h3-heading">' + $subheading.html() + '</h3>'
        );
    }

    $('.collection__products .product-item h4.product-item__product-title').each(function () {
        const newH3 = $('<h3>', {
            class: this.className,
            html: $(this).html()
        });

        $(this).replaceWith(newH3);
    });

   const $titleBlog = $('.blog__header .blog__heading');
    if ($titleBlog.length && $titleBlog.is('h1')) {
        $titleBlog.replaceWith(
        '<h2 class="' + $titleBlog.attr('class') + '">' + $titleBlog.html() + '</h2>'
        );
    }

    const $titleArticle = $('.article__header .article__heading');
    if ($titleArticle.length && $titleArticle.is('h1')) {
        $titleArticle.replaceWith(
        '<h2 class="' + $titleArticle.attr('class') + '">' + $titleArticle.html() + '</h2>'
        );
    }

    const $titleArticleDate = $('.article__header .article__date');
    if ($titleArticleDate.length && $titleArticleDate.is('p')) {
        $titleArticleDate.replaceWith(
        '<h3 class="' + $titleArticleDate.attr('class') + '">' + $titleArticleDate.html() + '</h2>'
        );
    }

    const $titlePage = $('.page__header .page__heading');
    if ($titlePage.length && $titlePage.is('h1')) {
        $titlePage.replaceWith(
        '<h2 class="' + $titlePage.attr('class') + '">' + $titlePage.html() + '</h2>'
        );
    }

    const $titleH4 = $('h4.ff-heading');
    if ($titleH4.length && $titleH4.is('h4')) {
        $titleH4.replaceWith(
        '<h2 class="' + $titleH4.attr('class') + '">' + $titleH4.html() + '</h2>'
        );
    }

    $('.featured-collection__slide .product-item h4.product-item__product-title').each(function () {
        const newH3 = $('<h3>', {
            class: this.className,
            html: $(this).html()
        });

        $(this).replaceWith(newH3);
    });

    const $titleProduct = $('.product .product__title');
    if ($titleProduct.length && $titleProduct.is('h1')) {
        $titleProduct.replaceWith(
        '<h2 class="' + $titleProduct.attr('class') + '">' + $titleProduct.html() + '</h2>'
        );
    }


    $('.product__description-content h5').each(function () {
        const newH4 = $('<h4>', {
            class: this.className,
            html: $(this).html()
        });

        $(this).replaceWith(newH4);
    });

    const $titleProductH4 = $('#shopify-section-template--20068264706279__rich_text_et4BYb h4');
    if ($titleProductH4.length && $titleProductH4.is('h4')) {
        $titleProductH4.replaceWith(
        '<h2 class="' + $titleProductH4.attr('class') + '">' + $titleProductH4.html() + '</h2>'
        );
    }


    $('h4.testimonials__item-heading').each(function () {
        const newH2 = $('<h2>', {
            class: this.className,
            html: $(this).html()
        });
        $(this).replaceWith(newH2);
    });

  

    
    setTimeout(function () {
        let $div = $('div[aria-label^="Shipment"]'); 
        let label = $div.attr('aria-label');    
        let match = label.match(/(\d{4}-\d{2}-\d{2})/);

        if (match) {
            let dateStr = match[1];        
            let dateObj = new Date(dateStr);
            let options = { year: 'numeric', month: 'short', day: 'numeric' };
            let formatted = dateObj.toLocaleDateString('en-US', options); 
            $div.attr('aria-label', `Next shipment on ${formatted}`);
        }
   
     }, 4000);

     $('.account__table td[scope="row"]').removeAttr('scope');

     setTimeout(function () {        
        $('.rebuy-checkbox-label').attr('for', 'rebuy-addon-checkbox');
        $('.rebuy-addon__item-checkbox input[type="checkbox"]').attr('id', 'rebuy-addon-checkbox');        
        
     }, 5000);

    

     

    




  });

document.addEventListener("DOMContentLoaded", function () {
    const el = document.querySelector('.rebuy-cart__flyout-content ul.rebuy-cart__flyout-items[role="group"]');
    if (el) {
        el.setAttribute("role", "list");
    }
});

